import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../Home/Footer";
import "./StrategicInterventions.css";

const interventions = [
  {
    number: 1,
    title: "Enhancing Agricultural Productivity",
    description:
      "IPDA is working towards strengthening seed systems and promoting market-led varietal replacement while enhancing productivity and climate resilience through improved agronomic practices.",
  },
  {
    number: 2,
    title: "Unlocking Value Addition",
    description:
      "With India's rising demand for plant-based protein, IPDA is promoting value addition in pulses through protein extraction and innovative processing techniques to unlock new market opportunities, support MSMEs and FPOs, and enhance farmer’s income.",
  },
  {
    number: 3,
    title: "Policy Advocacy",
    description:
      "To ensure long-term impact and systemic change, IPDA seeks to constantly engage all key value chain actors—farmers, FPOs, seed companies, researchers, input suppliers, processors, and policymakers—to drive supportive reforms.",
  },
];

const StrategicInterventions = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="strategic-wrapper">
      {/* Header */}
      <section className="strategic-header separator-title" data-aos="fade-up">
        <h2>Strategic Interventions</h2>
        <div className="separator-line"></div>
      </section>

      {/* Steps */}
      <section className="strategic-steps" data-aos="fade-up">
        {interventions.map((item, index) => (
          <div
            key={index}
            className={`step-card ${index % 2 === 0 ? "left" : "right"}`}
          >
            <div className="step-circle">{item.number}</div>
            <div className="step-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </section>

      <Footer />
    </div>
  );
};

export default StrategicInterventions;
